import { isOnMobileDevice } from 'js/src/libs/mobile-check';
import { getServiceLevel, hasFeatureEnabled, ServiceLevel } from 'js/src/libs/server-utils';
import type { DAMConfig } from 'js/src/typings/global';
import Cookies from 'js-cookie';

const Flags = {
    canUseStaffControls: (): boolean => {
        return hasFeatureEnabled('staff_controls');
    },
    canSeeDamTab: (): boolean => {
        if (!window.SERVER?.USER?.dam_configs) {
            return false;
        }
        const damConfigs = window.SERVER.USER.dam_configs;
        return damConfigs.some((damConfig: DAMConfig) => {
            if (damConfig.require_connection && damConfig.is_connected) {
                return true;
            }
            if (!damConfig.require_connection) {
                return true;
            }
            return false;
        });
    },
    canSeeAiContextSettings: () => {
        return hasFeatureEnabled('ai_context_settings');
    },
    canUseChat: () => {
        return hasFeatureEnabled('chat');
    },
    chatTabDeveloperToolsEnabled: () => {
        return hasFeatureEnabled('sketch_show_dev_details');
    },
    chartsTabDeveloperToolsEnabled: () => {
        return Cookies.get('charts_tab_developer_tools') === 'true';
    },
    canUseScreenRecording: () => {
        return window.SERVER?.USER?.capabilities?.screen_recording ?? true;
    },
    canUseBlueprintAgent: () => {
        return hasFeatureEnabled('blueprint_agent');
    },
    canUseImproveMediaAgent: () => {
        return process.env.NODE_ENV !== 'test';
    },
    canUseAgentFamily: () => {
        if (getServiceLevel() === ServiceLevel.HIGH) {
            return Flags.canUseImproveMediaAgent() || Flags.canUseBlueprintAgent();
        } else {
            return false;
        }
    },
    canUseVideoGeneration: () => {
        return hasFeatureEnabled('video_generation');
    },
    canUseBuildVideoFromMediaAgent: () => {
        return hasFeatureEnabled('build_video_from_media_agent');
    },
    canUseBuildGenerativeMediaVideoAgent: () => {
        return hasFeatureEnabled('build_video_with_generative_media_agent');
    },
    canUseSketchModes: () => {
        return (
            Flags.canUseBuildVideoFromMediaAgent() || Flags.canUseBuildGenerativeMediaVideoAgent()
        );
    },
    canUseMediaAge: () => {
        return hasFeatureEnabled('enrich_media_age');
    },
    canUseMorphTransitions: () => {
        return hasFeatureEnabled('morph_transitions');
    },
    isDefaultSketchEnabled: () => {
        return hasFeatureEnabled('default_sketch') || isOnMobileDevice();
    },
    canUseChartGeneration: () => {
        return hasFeatureEnabled('chart_generation');
    },
    canUseCanvasTextEditing: () => {
        return hasFeatureEnabled('canvas_text_editing');
    },
    canUseTextInElementsTab: () => {
        return hasFeatureEnabled('text_in_elements_tab');
    },
    canUseNewAiVoiceoverModal: () => {
        return hasFeatureEnabled('new_ai_voiceover_modal');
    },
};

export default Flags;
